"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddMembersStep = void 0;
const react_1 = __importDefault(require("react"));
const stream_chat_react_1 = require("stream-chat-react");
const i18n_1 = require("@app/util/i18n");
const store_1 = require("@app/store");
const ui_1 = require("@app/component/ui");
const useTeamMembers_1 = require("@app/util/hooks/chat/useTeamMembers");
const error_handler_1 = require("@app/util/error-handler");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
function AddMembersStep({ goBack }) {
    const { channel } = (0, stream_chat_react_1.useChatContext)();
    const workspaceId = (0, store_1.useRootSelector)((state) => state.workspaceId);
    const [selectedMembers, setSelectedMembers] = react_1.default.useState([]);
    const blacklistedMembers = react_1.default.useMemo(() => {
        const existingMembers = channel?.state?.members;
        if (!existingMembers)
            return [];
        return Object.keys(existingMembers);
    }, []);
    const { teamMembers, isFetching } = (0, useTeamMembers_1.useTeamMembers)({
        onError: goBack,
        workspaceId,
    });
    const availableMembers = react_1.default.useMemo(() => {
        return blacklistedMembers
            ? teamMembers.filter((m) => !blacklistedMembers.includes(m.id))
            : teamMembers;
    }, [blacklistedMembers, teamMembers]);
    const [isAddingMembers, setIsAddingMembers] = react_1.default.useState(false);
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    async function addMemberHandler() {
        setIsAddingMembers(true);
        try {
            await channel?.addMembers(selectedMembers);
            goBack();
        }
        catch (error) {
            console.error('addMemberMutation failed', { error });
            goBack();
            (0, error_handler_1.processErrors)([], (0, maybe_unwrap_1.unwrapMaybe)((0, i18n_1.t)('ERR_MESSAGE.error')));
        }
    }
    return (react_1.default.createElement(ui_1.Modal, { size: ui_1.Modal.SIZES.M, headerContent: react_1.default.createElement("div", { className: 'ds-title' }, (0, i18n_1.t)('ADD')), footerContent: isFetching ? undefined : (react_1.default.createElement(ui_1.Flex, { grow: 1 },
            react_1.default.createElement(ui_1.Button, { size: ui_1.Button.SIZES.FULL, onClick: goBack, label: (0, i18n_1.t)('CANCEL'), disabled: isAddingMembers }),
            react_1.default.createElement(ui_1.Button, { size: ui_1.Button.SIZES.FULL, style: ui_1.Button.STYLES.CONTAINED, onClick: async () => await addMemberHandler(), label: (0, i18n_1.t)('ADD'), loading: isAddingMembers }))), sections: [
            react_1.default.createElement("div", { key: 'first-section' }, isFetching || isAddingMembers ? (react_1.default.createElement(ui_1.Loader, { size: ui_1.Loader.SIZES.SMALL })) : (react_1.default.createElement(ui_1.EmployeeList, { key: 'members', withSearch: true, employees: availableMembers, selected: selectedMembers, onSelectChange: (employee) => {
                    setSelectedMembers((current) => {
                        if (current.includes(employee.id)) {
                            return current.filter((memberId) => memberId !== employee.id);
                        }
                        return [...current, employee.id];
                    });
                } }))),
        ] }));
}
exports.AddMembersStep = AddMembersStep;
